import { useMsal } from "@azure/msal-react";

export const SignOutButton = () => {
  const { instance } = useMsal();

  return (
    <button
      onClick={() => instance.logoutRedirect()}
      className="flex items-center justify-center w-10 h-10 rounded-full
                       bg-white/20 hover:bg-white/30 transition-colors duration-200
                       focus:outline-none focus:ring-2 focus:ring-white"
      aria-label="Sign out"
    >
      <svg
        className="w-6 h-6 text-white"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
      </svg>
    </button>
  );
};
